D.Blog = {};

const SectionBlog = Class(
	/**
	 * @lends {SectionBlog#}
	 */
	{
		route() {
			const part = this.url.shift();
			if (part === String(parseInt(part))) {
				return new SectionBlog.BlogItem;
			} else if (part) {
				return new SectionUnknown;
			}
			return new SectionBlog.Blog;
		}
	},
	Section
);

/**
 * @class
 * @extends Section
 */
SectionBlog.Base = Class(
	/**
	 * @lends {SectionBlog.Base#}
	 */
	{
		menuItem: 'blog',

		__construct() {
			this.node = mkE({
				tag: 'div',
				id: 'blog',
				className: 'SectionBlog'
			}).append(this.layout.ct());
		}
	},
	Section
);

/**
 * @class
 * @extends SectionBlog.Base
 */
SectionBlog.Blog = Class(
	/**
	 * @lends {SectionBlog.Blog#}
	 */
	{
		draw() {
			mkE({
				tag: 'div',
				className: 'container',
				els: [
					this._postsNode = mkE({
						tag: 'div',
						className: 'blog-posts'
					}),
					this._loadMore = mkE({
						tag: 'div',
						className: 'load-more',
						els: [
							{
								tag: 'a',
								className: 'button button-turquoise',
								text: D.Lang.get('blogs.loadMore'),
								onclick: this.loadMore
							}
						]
					})
				]
			}).append(this.node);

			mkE({
				tag: 'div',
				className: 'mb-4 container-wide blog__newsletter',
				els: [
					new T.NewsletterSignUp()
				]
			}).append(this.node);

			this._mGetItems = new DR.blog.GetItems();
			this._mGetItems.pg = 1;
			this._mGetItems.count = 7;
			this._mGetItems.select = [
				new DR.blog.select.Item().all(),
				new DR.roadgames.select.Image().all(),
				new DR.blog.select.Author().name()
			];
			this._mGetItems.onLoad = this._mGetItemsRe;
			this.apiCall.addMethod(this._mGetItems);

			this.apiCall.call();
		},

		_mGetItemsRe() {
			if (!this._mGetItems.re.items.length) {
				Section.navigate(D.url('/'));
				return;
			}

			for (let i = 0; i < this._mGetItems.re.items.length; i++) {
				const item = this._mGetItems.re.items[i];
				if (this._mGetItems.pg === 1 && i === 0) {
					new D.Blog.PostHero(item).append(this._postsNode);
				} else {
					new D.Blog.PostHorizontal(item).append(this._postsNode);
				}
			}

			if (this._mGetItems.pg >= this._mGetItems.re.pgs) {
				this._loadMore.remove();
				this._loadMore = null;
			}
		},

		loadMore() {
			if (this._mGetItems.processing) {
				return;
			}
			if (this._mGetItems.pg >= this._mGetItems.re.pgs) {
				this._loadMore.remove();
				this._loadMore = null;
				return;
			}
			this._mGetItems.pg++;
			this._mGetItems.call();
		}

	},
	SectionBlog.Base
);

/**
 * @class
 * @extends SectionBlog.Base
 */
SectionBlog.BlogItem = Class(
	/**
	 * @lends {SectionBlog.BlogItem#}
	 */
	{

		/** @type {DR.blog.GetItem} */
		_mGetItem: null,

		route() {
			this.id = +this.url.before;
		},

		draw() {
			mkE({
				tag: 'div',
				className: 'BlogItem',
				els: [
					this._itemNode = mkE({
						tag: 'div',
						className: 'container'
					}),
					{
						tag: 'div',
						className: 'contact container-wide mb-4',
						els: [
							new T.NewsletterSignUp()
						]
					},
					this._relatedItemsNode = mkE({
						tag: 'div',
						className: 'related-posts'
					})
				]
			}).append(this.node);

			this._mGetItem = new DR.blog.GetItem();
			this._mGetItem.id = this.id;
			this._mGetItem.select = [
				new DR.blog.select.Item().all(),
				new DR.roadgames.select.Image().all(),
				new DR.blog.select.Author().all()
			];
			this._mGetItem.onLoad = this._mGetItemRe;
			this._mGetItem.onError = this._mGetItemErr;
			this.apiCall.addMethod(this._mGetItem);

			this._mGetRelated = new DR.blog.GetRelated();
			this._mGetRelated.id = this.id;
			this._mGetRelated.select = [
				new DR.blog.select.Item().all(),
				new DR.roadgames.select.Image().all(),
				new DR.blog.select.Author().name()
			];
			this._mGetRelated.onLoad = this._mGetRelatedRe;
			this.apiCall.addMethod(this._mGetRelated);

			this.apiCall.call();
		},

		_mGetItemErr() {
			Section.navigate(D.url('/blog'));
		},

		_mGetItemRe() {
			const item = this._mGetItem.re;
			this.meta
				.setTitle(item.metaTitle || item.title)
				.setDescription(item.metaDescription || item.intro)
				.setOgImage(item.cover.image.original)
				.setCanonical(item.url)
				.setAlternates(item.url, [], item.lang)
			new D.Blog.PostFull(this._mGetItem.re).append(this._itemNode);
		},

		_mGetRelatedRe() {
			if (!this._mGetRelated.re.items.length) {
				return;
			}

			let posts = [];
			for (let i = 0; i < this._mGetRelated.re.items.length; i++) {
				const item = this._mGetRelated.re.items[i];
				posts.push(new D.Blog.PostSmall(item));
			}

			mkE({
				tag: 'div',
				className: 'container',
				els: [
					{
						tag: 'h2',
						text: D.Lang.get('blog.related_posts')
					},
					{
						tag: 'div',
						className: 'items',
						els: posts
					}
				]
			}).append(this._relatedItemsNode);
		}
	},
	SectionBlog.Base
);

/**
 * @class
 * @param {DR.blog.struct.Item} item
 * @extends mkE.Base
 */
D.Blog.PostHero = Class(
	/**
	 * @lends {D.Blog.PostHero#}
	 */
	{
		/** @type {DR.blog.struct.Item} */
		item: null,

		/** @param {DR.blog.struct.Item} item */
		__construct(item) {
			this.item = item;

			this.node = mkE({
				tag: 'article',
				className: 'blog-post blog-post-hero',
				style: {
					backgroundImage: 'url(' + this.item.cover.image.large + ')'
				},
				els: [
					{
						tag: 'a',
						className: 'body',
						href: D.url(this.item.url),
						els: [
							{
								tag: 'section',
								className: 'tags',
								els: function() {
									let els = [];
									for (let i = 0; i < item.tags.length; i++) {
										const tag = item.tags[i];
										els.push({
											tag: 'span',
											// href: D.url('/blog/search/?tag=' + tag),
											text: tag
										});
									}
									return els;
								}()
							},
							{
								tag: 'h2',
								className: 'title',
								text: this.item.title
							},
							{
								tag: 'section',
								className: 'intro',
								text: this.item.intro
							},
							{
								tag: 'section',
								className: 'info',
								els: [
									{
										tag: 'time',
										attr: {
											datetime: new D.Date(this.item.pubDate).format('Y-m-d H:i:s')
										},
										text: new D.Date(this.item.pubDate).format(D.Lang.get('blog.date_format'))
									},
									' ',
									{
										tag: 'span',
										className: 'author',
										text: this.item.author.name
									},
									' ' + D.Lang.get('blog.author_preposition') + ' ',
									{
										tag: 'span',
										className: 'author',
										text: 'Roadgames'
									}
								]
							}
						]
					}
				]
			});
		}
	},
	mkE.Base
);

/**
 * @class
 * @param {DR.blog.struct.Item} item
 * @extends mkE.Base
 */
D.Blog.PostHorizontal = Class(
	/**
	 * @lends {D.Blog.PostHorizontal#}
	 */
	{
		/** @type {DR.blog.struct.Item} */
		item: null,

		/** @param {DR.blog.struct.Item} item */
		__construct(item) {
			this.item = item;
			this.node = mkE({
				tag: 'article',
				className: 'blog-post blog-post-horizontal'
			});
			this.draw();
		},

		draw() {
			let item = this.item;
			let tags = {
				tag: 'section',
				className: 'tags',
				els: function() {
					let els = [];
					for (let i = 0; i < item.tags.length; i++) {
						const tag = item.tags[i];
						els.push({
							tag: 'span',
							// href: D.url('/blog/search/?tag=' + tag),
							text: tag
						});
					}
					return els;
				}()
			};
			let title = {
				tag: 'h3',
				className: 'title',
				els: [
					{
						tag: 'a',
						href: D.url(this.item.url),
						text: this.item.title
					}
				]
			};
			let info = {
				tag: 'section',
				className: 'info',
				els: [
					{
						tag: 'time',
						attr: {
							datetime: new D.Date(this.item.pubDate).format('Y-m-d H:i:s')
						},
						text: new D.Date(this.item.pubDate).format(D.Lang.get('blog.date_format'))
					},
					' ',
					{
						tag: 'span',
						className: 'author',
						text: this.item.author.name
					},
					' ' + D.Lang.get('blog.author_preposition') + ' ',
					{
						tag: 'span',
						className: 'author',
						text: 'Roadgames'
					}
				]
			};
			let cover = {
				tag: 'section',
				className: 'cover',
				els: [
					{
						tag: 'a',
						href: D.url(this.item.url),
						els: [
							{
								tag: 'img',
								alt: this.item.coverAltText || 'Cover image',
								src: this.item.cover.image.large
							}
						]
					}
				]
			};
			let layout;
			if (D.CSS.brTablet) {
				layout = [
					tags,
					{
						tag: 'section',
						className: 'body',
						els: [
							{
								tag: 'div',
								els: [
									title,
									info
								]
							},
							{
								tag: 'div',
								els: [
									cover
								]
							}
						]
					}
				];
			} else {
				layout = [
					{
						tag: 'section',
						className: 'body',
						els: [
							tags,
							title,
							info
						]
					},
					cover
				];
			}

			mkE.appendTypeElement(this.node, layout);
		}
	},
	mkE.Base
);

/**
 * @class
 * @param {DR.blog.struct.Item} item
 * @extends mkE.Base
 */
D.Blog.PostSmall = Class(
	/**
	 * @lends {D.Blog.PostSmall#}
	 */
	{
		/** @type {DR.blog.struct.Item} */
		item: null,

		/** @param {DR.blog.struct.Item} item */
		__construct(item) {
			this.item = item;

			this.node = mkE({
				tag: 'article',
				className: 'blog-post blog-post-small',
				els: [
					{
						tag: 'div',
						className: 'cover',
						els: [
							{
								tag: 'a',
								href: D.url(this.item.url),
								els: [
									{
										tag: 'img',
										alt: this.item.coverAltText || 'Cover image',
										src: this.item.cover.image.large
									}
								]
							}
						]
					},
					{
						tag: 'h4',
						className: 'title',
						els: [
							{
								tag: 'a',
								href: D.url(this.item.url),
								text: this.item.title
							}
						]
					}
				]
			});
		}
	},
	mkE.Base
);

/**
 * @class
 * @param {DR.blog.struct.Item} item
 * @extends mkE.Base
 */
D.Blog.PostFull = Class(
	/**
	 * @lends {D.Blog.PostFull#}
	 */
	{
		/** @param {DR.blog.struct.Item} item */
		__construct(item) {
			this.item = item;

			this.node = mkE({
				tag: 'article',
				className: 'blog-post blog-post-full'
			});

			let els = [];
			for (let i = 0; i < item.tags.length; i++) {
				const tag = item.tags[i];
				els.push({
					tag: 'span',
					// href: D.url('/blog/search/?tag=' + tag),
					text: tag
				});
			}

			mkE({
				tag: 'section',
				className: 'tags',
				els: els
			}).append(this.node);

			mkE({
				tag: 'header',
				els: [
					{
						tag: 'h1',
						className: 'title',
						text: this.item.title
					}
				]
			}).append(this.node);

			mkE({
				tag: 'section',
				className: 'wrapper',
				els: [
					{
						tag: 'section',
						className: 'info',
						els: [
							{
								tag: 'div',
								className: 'author-image',
								style: {
									backgroundImage: 'url(' + this.item.author.image.small + ')'
								}
							},
							{
								tag: 'div',
								className: 'author-time',
								els: [
									{
										tag: 'time',
										attr: {
											datetime: new D.Date(this.item.pubDate).format('Y-m-d H:i:s')
										},
										text: new D.Date(this.item.pubDate).format(D.Lang.get('blog.date_format'))
									},
									{
										tag: 'div',
										className: 'author',
										els: [
											' ',
											{
												tag: 'span',
												text: this.item.author.name
											},
											' ' + D.Lang.get('blog.author_preposition') + ' ',
											{
												tag: 'span',
												text: 'Roadgames'
											}
										]
									}
								]
							},
							{
								tag: 'div',
								className: 'share',
								els: [
									{
										tag: 'a',
										className: 'share-facebook',
										target: '_blank',
										attr: {
											rel: 'nofollow'
										},
										href: this._shareUrlFacebook()
									},
									{
										tag: 'a',
										className: 'share-twitter',
										target: '_blank',
										attr: {
											rel: 'nofollow'
										},
										href: this._shareUrlTwitter()
									},
									{
										tag: 'a',
										className: 'share-draugiem',
										target: '_blank',
										attr: {
											rel: 'nofollow'
										},
										href: this._shareUrlDraugiem()
									},
									{
										tag: 'a',
										className: 'share-linkedin',
										target: '_blank',
										attr: {
											rel: 'nofollow'
										},
										href: this._shareUrlLinkedIn()
									}
								]
							}
						]
					},
					{
						tag: 'section',
						className: 'body',
						els: [
							this.item.hasCover ? {
								tag: 'section',
								className: 'cover',
								els: [
									{
										tag: 'img',
										className: 'cover',
										alt: this.item.coverAltText || 'Cover image',
										src: this.item.cover.image.large
									}
								]
							} : '',
							{
								tag: 'section',
								className: 'ck-content',
								innerHTML: this.item.html
							}
						]
					}
				]
			}).append(this.node);

			this._drawFaq();
		},

		_drawFaq() {
			if (!this.item.qa || !this.item.qa.length) {
				return;
			}
			new T.FAQ({
				questions: this.item.qa,
				className: 'container'
			}).append(this.node);
		},

		shareUrl(source) {
			const get = new Get('https://www.roadgames.com/' + D.LANG + '' + this.item.url);
			get.add('utm_source', source);
			get.add('utm_medium', 'social');
			get.add('utm_campaign', 'blog-share');
			get.add('utm_content', this.item.id);
			return get.toUrl();
		},

		_shareUrlFacebook() {
			const get = new Get('https://www.facebook.com/sharer/sharer.php');
			get.add('u', this.shareUrl('facebook.com'));
			return get.toUrl();
		},

		_shareUrlDraugiem() {
			const get = new Get('https://www.draugiem.lv/say/ext/add.php');
			get.add('title', '');
			get.add('link', this.shareUrl('draugiem.lv'));
			return get.toUrl();
		},

		_shareUrlTwitter() {
			const get = new Get('https://twitter.com/share');
			get.add('text', '');
			// get.add('hashtags', '');
			get.add('url', this.shareUrl('twitter.com'));
			return get.toUrl();
		},

		_shareUrlLinkedIn() {
			const get = new Get('https://www.linkedin.com/sharing/share-offsite/');
			get.add('url', this.shareUrl('linkedin.com'));
			return get.toUrl();
		}
	},
	mkE.Base
);